import React from "react";
import "./Intro.css";
import img1 from '../photos/him-chatterjee.jpg' // tumhare photo ka path
import { Fade } from "react-awesome-reveal";

function Intro() {
    return (
        <div className="about-container">
            {/* Header Section with Photo */}
            <div className="about-header">
                <Fade direction="down" triggerOnce={false}>
                    <div className="photo-container">
                        <img src={img1} alt="Him Chatterjee" className="profile-photo" />
                    </div>

                    <div className="intro-text">
                        <h1 style={{
                            color: "red",
                            fontSize: 30,
                            fontWeight: "600",

                        }} >Prof. Him kumar Chatterjee</h1>
                        <h3 style={{
                            textAlign: 'center',
                        }}>Vice-Chancellor</h3>
                        <p style={{
                            textAlign: 'center',
                        }}>Sir J. J. School of Art, Architecture & Design</p>
                        <p style={{
                            textAlign: 'center',
                            fontSize: '0.8rem',
                        }}>(Deemed To Be University Under De-novo Category)</p>
                        <p style={{
                            textAlign: 'center',
                            fontSize: '0.8rem',
                        }}>78, Dr. D. N. Road, Fort, Mumbai-400 001.</p>
                        <p style={{
                            textAlign: 'center',
                            fontSize: '0.8rem',
                        }}>+91 9816060237 / 022-2517 2175/vc@sirjjuniv.in</p>
                    </div>
                </Fade>
            </div>

            {/* Main Content */}
            <div className="about-content">
                <Fade direction="right" triggerOnce={false}>
                    <p>
                        "Sanat Art Foundation" - S.A.F. <br />
                        Established the first professional contemporary Art gallery cum Art
                        residency in Himachal at village Hiun, near Chadwick Fall Shimla.
                    </p>
                </Fade>

                <Fade direction="left" triggerOnce={false}>
                    <p>
                        For some people, life and colours are almost synonymous. They fill
                        colour in life and instill life in colour. Him Chatterjee is one such
                        person.  He is a Vice-Chancellor of Sir J. J. School of Art, Architecture & Design, Mumbai.
                        He is known for his master strokes with brush and colours.These are to be seen to be believed.
                        Give him a piece of canvas and a brush, and it will burst into colours;
                        give him pen or pencil and a sketch will materialize as if from nowhere;
                        give him Charcoal and paper and see the wonder of his drawings.
                    </p>
                </Fade>

                <Fade direction="right" triggerOnce={false}>
                    <p>
                        Art is in Him Chatterjee's blood. His father, Shri Sanat Chatterjee,
                        is a renowned artist of Bengal School. Him blends mythology and
                        folklore with nature. He paints mountains in their various moods and
                        colours.This should not surprise us though, because Him was born in Shimla,
                        Himachal Pradesh and has travelled a lot as a tourist,
                        a trekker and a researcher.
                        He has photographed nature, painted her and sketched her.
                    </p>
                </Fade>

                <Fade direction="left" triggerOnce={false}>
                    <p>
                        Professor Chatterjee has earned repute for his expertise in murals,
                        paintings, sketches, and drawings. His important assignments  include his more than 100 murals and Art works designed
                        and installed at the different corners of India- in Varanasi International, Jammu and Goa Airports,
                        CAG office-New Delhi, DDU College Dwarka, New Delhi, SSD college Rohini, New Delhi, On Delhi New Flyovers,
                        NSG-HQ-New Delhi, at Maneser, Gurgaon, at Mall Road- Solan , at Mall Road- Shimla, NAAA Shimla ,
                        portrait at Parliament House- New Delhi etc.
                        His abstract landscapes on canvases and pen drawings of several historical buildings of India display high quality.
                        His exhibits feature in many Art galleries, Indian Institute for Advance Study, Shimla, Parliament House, New Delhi
                        and in many prominent public places in India.
                    </p>
                </Fade>

                <Fade direction="right" triggerOnce={false}>
                    <p>
                        Among his several National and State-level awards are recognitions
                        given for his contribution to the field of art by the Vishwa Hindu
                        Parishad, International Film Festival New Delhi (2014), NGO
                        Sanchetna (2009), Himachal Pradesh Shikhar Samman (2017), and Rashtriya
                        Sawasti Samman by Kalavart Nayas, 23rd International Art Festival,
                        Ujjain, M.P. (2018).
                    </p>
                </Fade>


                <Fade direction="left" triggerOnce={false}>
                    <p>
                        He is an Art Advisor/Consultant/Curator for Airport Authority of India,
                        Larsen & Toubro (L&T), Lalit Kala Academy, PWD New Delhi, Industry and
                        Culture Department of Himachal Pradesh. He has participated in more
                        than 80 National and International Seminars and Art Workshops, more
                        than 70 group shows, and held 11 Solo shows.
                    </p>
                </Fade>

                <Fade direction="right" triggerOnce={false}>
                    <p>
                        His Art Gallery - S.A.F. (Sanat Art Foundation) is one of the most
                        visited places in Shimla.
                    </p>
                </Fade>
            </div>
        </div>
    );
}

export default Intro;
